<template>
  <div v-if="variants.v1 === variant" style="position: relative">
    <div>
      <library-container class="tw-flex tw-flex-col tw-py-24">
        <div class="tw-mb-16 tw-text-center">
          <library-title :text="vars.titleText" tag="h2"></library-title>
        </div>
        <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-y-12 md:tw-gap-x-36 lg:tw-flex-row">
          <nuxt-link
            v-for="(item, index) in items"
            :key="`item-${key}-${index}`"
            :external="true"
            :to="item.button_link"
            class="tw-col-span-12 tw-flex tw-w-full tw-flex-col tw-gap-y-3 min-[400px]:tw-w-[370px] md:tw-col-span-6"
          >
            <library-image
              :src="item.photo"
              loading="lazy"
              :alt="vars.titleText"
              :w-ratio="1.5"
              :h-ratio="0.6667"
              image-class="pxp-cta-3-image pxp-cover rounded-lg tw-h-[230px] tw-w-[370px]"
            />
            <lazy-library-title tag="h3" :text="item.title"> </lazy-library-title>
            <div style="height: 180px">
              <lazy-library-text :text="item.description"></lazy-library-text>
            </div>
            <div class="pxp-primary-cta text-uppercase pxp-animate tw-mt-3 tw-text-sm">
              {{ item.button_label }}
            </div>
          </nuxt-link>
        </div>
      </library-container>
    </div>

    <div
      class="tw-absolute tw-right-0 tw-top-0 tw-h-full tw-w-0 xl:tw-w-[200px]"
      style="background-color: var(--purple)"
    ></div>
  </div>

  <div v-if="variants.v2 === variant" class="tw-relative tw-w-full tw-overflow-hidden">
    <div class="tw-absolute tw-bottom-[0px] tw-h-[85%] tw-w-full lg:tw-h-[65%]" style="background-color: #7f338f"></div>
    <library-container class="tw-relative tw-flex tw-w-full tw-flex-col tw-py-10 lg:tw-py-16">
      <!-- Başlık -->
      <div class="tw-mb-12 tw-text-center">
        <h3>{{ vars.titleText }}</h3>
      </div>

      <div class="tw-relative">
        <div
          class="tw-relative tw-z-10 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-x-10 tw-gap-y-12 lg:tw-flex-row xl:tw-gap-x-16"
        >
          <nuxt-link
            v-for="(item, index) in items"
            :key="`item-${key}-${index}`"
            :external="true"
            :to="item.button_link"
            class="n-link tw-flex tw-w-full tw-max-w-[470px] tw-shrink-0 tw-flex-col tw-gap-y-6 tw-px-4"
          >
            <library-image
              :src="item.photo"
              loading="lazy"
              :alt="item.title"
              :w-ratio="420"
              :h-ratio="280"
              image-class="pxp-cta-3-image pxp-cover rounded-lg tw-w-full tw-h-[330px]"
            />

            <h5 class="tw-text-start !tw-text-white">{{ item.title }}</h5>

            <p
              class="tw-overflow-hidden tw-whitespace-normal tw-break-words tw-text-start !tw-text-white tw-opacity-90"
            >
              {{ item.description }}
            </p>

            <button :to="item.button_link" :class="['tw-inline-block', 'tw-w-[250px]', `n-${item.button_type}`]">
              {{ item.button_label }}
            </button>
          </nuxt-link>
        </div>
      </div>
    </library-container>
  </div>

  <div
    v-if="variants.v3 === variant"
    class="tw-h-full tw-w-full tw-overflow-hidden"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <library-container class="tw-flex tw-w-full tw-flex-col tw-py-10 lg:tw-py-16">
      <!-- Başlık -->
      <div class="tw-mb-12 tw-text-center">
        <h3>{{ vars.titleText }}</h3>
      </div>

      <div class="">
        <div
          class="tw-z-10 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-x-10 tw-gap-y-12 lg:tw-flex-row xl:tw-gap-x-24"
        >
          <nuxt-link
            v-for="(item, index) in items"
            :key="`item-${key}-${index}`"
            :external="true"
            :to="item.button_link"
            class="n-link tw-flex tw-w-full tw-max-w-[470px] tw-shrink-0 tw-flex-col tw-gap-y-6 tw-px-4"
          >
            <library-image
              :src="item.photo"
              loading="lazy"
              :alt="item.title"
              :w-ratio="420"
              :h-ratio="280"
              image-class="pxp-cta-3-image pxp-cover rounded-lg tw-w-full tw-h-[330px]"
            />

            <h5 class="tw-text-start !tw-text-white">{{ item.title }}</h5>

            <p
              class="tw-h-[120px] tw-overflow-hidden tw-whitespace-normal tw-break-words tw-text-start !tw-text-white tw-opacity-90"
            >
              {{ item.description }}
            </p>

            <nuxt-link :to="item.button_link" :external="true" :class="['tw-inline-block', 'tw-w-[250px]', `n-${item.button_type}`]">
              {{ item.button_label }}
            </nuxt-link>
          </nuxt-link>
        </div>
      </div>
    </library-container>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { produceKey } from '~/server/core/helpers';

export default defineNuxtComponent({
  name: 'Theme3ClassicCardGridSection',

  mixins: [ComponentMixin],

  data(vm) {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },
      key: produceKey(),
    };
  },

  computed: {
    items() {
      return this.groupedVariables.items;
    },
  },
});
</script>
